var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Autosuggest',_vm._b({on:{"resultPicked":function($event){return _vm.$emit('input', $event)}}},'Autosuggest',{
    value: _vm.value,
    label: _vm.label,
    minLength: 2,
    disabled: !_vm.country,
    displayProperty: 'text',
    placeholder: _vm.$t('_web_filter_enter-city', 'Start enter city'),
    tabindex: _vm.tabindex,
    source: _vm.getCities,
  },false))}
var staticRenderFns = []

export { render, staticRenderFns }